import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Login } from './Login'
import { Logout } from './Logout'
import { ApplicationPaths, LoginActions, LogoutActions } from './ApiAuthorizationConstants';

export default class ApiAuthorizationRoutes extends Component {

  render () {
    return(
      <Routes>
          <Route path={ApplicationPaths.Login.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Login action={LoginActions.Login} />} />
          <Route path={ApplicationPaths.LoginFailed.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Login action={LoginActions.LoginFailed} />} />
          <Route path={ApplicationPaths.LoginCallback.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Login action={LoginActions.LoginCallback} />} />
          <Route path={ApplicationPaths.Profile.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Login action={LoginActions.Profile} />} />
          <Route path={ApplicationPaths.Register.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Login action={LoginActions.Register} />} />
          <Route path={ApplicationPaths.LogOut.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Logout action={LogoutActions.Logout} />} />
          <Route path={ApplicationPaths.LogOutCallback.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Logout action={LogoutActions.LogoutCallback} />} />
          <Route path={ApplicationPaths.LoggedOut.replace(ApplicationPaths.ApiAuthorizationPrefix + '/', '')} element={<Logout action={LogoutActions.LoggedOut} />} />
      </Routes>
    );
  }
}
